import React from 'react';

const HeroPreview = ({ backgroundImage, title, subtitle, buttonText }) => {
    return (
        <div className="relative w-full h-64 overflow-hidden bg-gradient-to-br from-stone-100 to-amber-100/40 rounded-lg border border-stone-300">
            {backgroundImage && (
                <div className="absolute inset-0">
                    <img
                        src={backgroundImage}
                        alt="Hero preview"
                        className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-black bg-opacity-30"></div>
                </div>
            )}
            <div className="absolute inset-0 bg-gradient-to-r from-stone-50/80 to-transparent"></div>

            <div className="relative h-full flex items-center px-8">
                <div className="max-w-lg">
                    <h1 className="text-2xl font-light text-stone-800 leading-tight mb-3">
                        {title}
                    </h1>
                    <p className="text-base text-stone-600 mb-4 line-clamp-3">
                        {subtitle}
                    </p>
                    <button className="bg-stone-800 text-white px-6 py-3 text-base rounded font-medium">
                        {buttonText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default HeroPreview;